import Box from '@mui/material/Box'
import { Typography } from '@mui/material'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import OfoqThemeBtn from '../Buttons/OfoqThemeBtn.jsx'
import FormModalContainer from './FormModalContainer.jsx'
import CheckSvg from '../../images/check.svg'
import UseTranslation from '../../hooks/UseTranslation.jsx'

const FinishModalContainer = ({
  modalState,
  modalChangeState,
  modalTitle,
  modalMessage,
  finishHandler,
  modalColor,
  customModalStyle,
  mediumSize,
  largeSize,
  messageCustomStyle,
}) => {
  const handleClose = () => modalChangeState(false)
  const newMessage = modalMessage?.split('"')
  const { t } = UseTranslation()
  return (
    <FormModalContainer
      modalState={modalState}
      handleClose={handleClose}
      modalTitle={t?.[modalTitle] || modalTitle}
      customModalStyle={customModalStyle}
      mediumSize={mediumSize}
      largeSize={largeSize}
      >
      <Box sx={styles.modalTxt}>
        <LazyLoadImage effect="blur" src={CheckSvg} alt={'Finish'} />
        <Typography variant="h6" sx={[styles.message, messageCustomStyle]}>
          {t?.[newMessage?.[0]] || newMessage?.[0]} <span style={{ color: `${modalColor && modalColor}` }}>{t?.[newMessage?.[1]] || newMessage?.[1]}</span>
          { t?.[newMessage?.[2]] || newMessage?.[2]}
        </Typography>
      </Box>

      <Box sx={styles.formModalBtnsContainer}>
        <OfoqThemeBtn onClick={finishHandler} name={t?.Finish} customStyle={styles.themeBtn} />
      </Box>
    </FormModalContainer>
  )
}

const styles = {
  formModalBtnsContainer: {
    display: 'flex',
    justifyContent: 'flex-end',
    margin: { xs: '10px -15px 0 -15px', sm: '20px -15px 0 -15px' },
    padding: { xs: '10px 15px 0', sm: '20px 15px 0' },
    borderTop: '1px solid #cbcbcb',
  },
  themeBtn: {
    minWidth: { xs: '100%', sm: 'auto' },
  },
  modalTxt: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    padding: { xs: '0 10px', sm: '0 60px' },
    marginTop: '-15px',
    '& .span': {
      display: 'block',
      marginBottom: '60px',
      marginTop: '-60px',
    },
    '& img': {
      width: { xs: '272px', sm: '372px' },
      height: { xs: '134px', sm: '295px' },
    },
  },
  message: {
    fontSize: { xs: '14px', sm: '16px' },
    '& span': {
      color: 'primary.main',
      mx: '5px',
    },
  },
}

export default FinishModalContainer
